import { EpiOrder, EpiOrderStatuses, useGetEpiOrdersMutation } from '@services';
import { useEffect, useState } from 'react';

export const useEpiOrdersPageVM = () => {
    const [orders, setOrders] = useState<EpiOrder[]>([]);
    const [errorMessage, setErrorMessage] = useState<string>('');

    const [getEpiOrders, { data, isLoading, isError }] = useGetEpiOrdersMutation();

    useEffect(() => {
        getEpiOrders();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isLoading) {
            return;
        }

        if (data) {
            setOrders(data);
        }

        if (isError) {
            setErrorMessage('Une erreur est survenue lors du chargement des demandes EPI');
        }
    }, [data, isLoading, isError]);

    return {
        currentOrders: orders.filter((order) => order.status === EpiOrderStatuses.CREATED),
        pastOrders: orders.filter((order) => order.status !== EpiOrderStatuses.CREATED),
        isLoading,
        errorMessage
    };
};
